import Link from 'next/link';
import type { FC } from 'react';

import Text from '@/components/Text';
import type { ExternalOffer } from '@/services/external-offers';

import NewOfferChip from '../NewOfferChip';
import { formatSalaryInThousands, toAnnualSalary } from '../OfferSalary';

const SimilarRoleCard: FC<ExternalOffer> = ({
  id,
  jobTitle,
  companyName,
  createdAt,
  salaryLower,
  salaryPeriod,
  salaryCurrency,
}) => (
  <Link
    href={{ pathname: '/jobs/[id]', query: { id: id.toString() } }}
    className="flex w-52 shrink-0 snap-start flex-col gap-1 rounded-2xl border border-jb-neutral-400 bg-jb-neutral-100 p-4 shadow transition-shadow hover:shadow-md"
  >
    <Text
      variant="jb-body-small"
      title={jobTitle}
      className="truncate font-semibold text-jb-primary-500"
    >
      {jobTitle}
    </Text>
    <Text
      variant="jb-body-small"
      title={companyName}
      className="truncate text-jb-neutral-700"
    >
      {companyName}
    </Text>
    {salaryLower && (
      <Text variant="jb-body-small" className="font-medium text-jb-success-600">
        From{' '}
        {formatSalaryInThousands(
          toAnnualSalary(salaryLower, salaryPeriod),
          salaryCurrency
        )}
      </Text>
    )}
    <div className="flex">
      <NewOfferChip createdAt={new Date(createdAt)} />
    </div>
  </Link>
);

export default SimilarRoleCard;
